import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';

import { AuthService } from '../services/auth.service';
import { ADMINISTRATOR } from '../services/user.service';

@Injectable({ providedIn: 'root' })
export class IntegrationProposerGuard implements CanActivate, CanActivateChild {

  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean | UrlTree {
    const user = this.authService.getUser();

    if (user && (user.profile_id === ADMINISTRATOR || user.can_propose_integrations === true)) {
      return true;
    }

    return this.router.parseUrl('/dashboard');
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    return this.canActivate(route, state);
  }
}
